import { LocationClientService, CountryModel } from '@/types/locationServerApi';
import { computed, Ref, ref } from 'vue';
import siteContextService from '@/b2c/shared/site-context.service';
import utilities from '@/shared/utilities.service';
import Deferred from '@/core/async/Deferred';
import httpService from '@/core/http/http.service';

export const countriesCancellationKey = 'callingCodesCancellationKey';

let loaded: boolean = false;
let suggestedCountryIsSet: boolean = false;
let suggestedCountryCode: Promise<string>;
const countries: Ref<CountryModel[]> = ref([] as CountryModel[]);

export default function useCountries() {
    const fetchCountries = async(): Promise<void> => {
        if (!loaded) {
            loaded = true;
            try {
                const response = await LocationClientService.getCountries(countriesCancellationKey).then(utilities.unwrapModel);
                countries.value = response ?? [] as CountryModel[];
            } catch (e) {
                loaded = false;
            }
        }
    };

    const getSuggestedCountry = async() => {
        if (suggestedCountryIsSet) {
            const deferred = new Deferred<string>();
            deferred.resolve(await suggestedCountryCode);
            return deferred.promise;
        } else {
            suggestedCountryIsSet = true;
            suggestedCountryCode = getSuggestedCountryCode();
            const deferred = new Deferred<string>();
            deferred.resolve(await suggestedCountryCode);
            return deferred.promise;
        }
    };

    const getSuggestedCountryCode = ():Promise<string> => {
        return httpService.get<string>('/api/location/suggestedcountry');
    };

    const redirectToSuggestCountrySite = async(suggestedCountryCode: string): Promise<string> => {
        const payload = {
            countryCode: suggestedCountryCode,
            referer: '/en',
        };
        return await httpService.post('/api/country/page-alternative', payload);
    };

    const siteCountryCode: Ref<string> = computed(() => {
        return siteContextService.country ? siteContextService.country.code : '';
    });

    const getCountryNameFromCode = (code: string): string => {
        return countries.value?.find(c => c.code === code)?.name ?? code;
    };

    const siteCountryName: Ref<string> = computed(() => {
        return getCountryNameFromCode(siteCountryCode.value);
    });

    fetchCountries();

    return {
        loaded: computed(() => loaded),
        countries,
        siteCountryCode,
        siteCountryName,
        getCountryNameFromCode,
        getSuggestedCountry,
        redirectToSuggestCountrySite,
    };
}
